<template>
    <div class="tags">

        <div :class="tooLongTagClass">
            #too-long
        </div>
        <div :class="stateTagClass">
            {{ tagText }}
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { useI18n } from 'vue-i18n'

    import { TranslationSegment } from '@/models/TranslationSegment';
    import { TranslationState } from '@/models/TranslationState';
    import { SegmentStatus } from '@/models/SegmentStatus';
    import { segmentTextLogicService } from '@/services/translationSegment/segmentTextLogicService';

    export default defineComponent({
        name: 'TranslationTags',
        props: {
            modelValue: {
                type: Object as PropType<TranslationSegment>,
                required: true
            },
        },
        setup() {
            const { t } = useI18n()
            return { t }
        },
        data() {
            return {
                segmentService: segmentTextLogicService.getInstance(),
            };
        },
        computed: {
            segment(): TranslationSegment {
                return this.modelValue;
            },
            isTooLong(): boolean {
                return this.segment.segmentStatus === SegmentStatus.TargetReach500Limit
                    || this.segment.segmentStatus === SegmentStatus.SourceAndTargetReach500Limit;
            },

            stateTagClass(): object {
                return {
                    'tag': this.showStateTag,
                    'tag--hidden': !this.showStateTag
                };
            },

            showStateTag(): boolean {
                switch (this.segment.translationState) {
                    case TranslationState.Draft:
                        return true;
                    case TranslationState.PreTranslated:
                        return true;
                    case TranslationState.Translated:
                        return !this.segmentService.drftStyleEqalTranslationStyle(this.segment);
                    case TranslationState.AutoTranslated:
                        return true;
                    default:
                        return false;
                }
            },

            tooLongTagClass(): object {
                return {
                    'tag': true,
                    'tag--hidden': !this.isTooLong
                };
            },

            tagText(): string {
                const state = this.segment.translationState;

                if (state === TranslationState.Draft) {
                    return this.segmentService.perfectMatch(this.segment)
                        ? this.t('segmentState.edit')
                        : this.t('segmentState.draft');
                }

                if (state === TranslationState.PreTranslated) {
                    return this.t('segmentState.fuzzyMatch');
                }

                if (state === TranslationState.Translated) {
                    return this.t('segmentState.styleChanged');
                }

                if (state === TranslationState.AutoTranslated) {
                    return this.t('segmentState.auto');
                }

                return '';
            }
        }
    });
</script>

<style lang="scss" scoped>
    .tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .tag {
        padding: 0 10px;
        height: 16px;
        font-size: 14px;
        border-radius: 25px;
        font-weight: 600;
        background-color: #CECECE;
        color: #7f7d7d;
        display: flex;
        align-items: center;
        margin-left: 3px;
        line-break: anywhere;
    }

    .tag--hidden {
        opacity: 0;
        visibility: hidden;
        height:0;
    }
</style>